import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/CommitteeTable.css';

const CollegeCouncil = () => {
  const members = [
    { sl: 1, name: 'Dr. M. Jayasree', designation: 'Dean', position: 'Chairperson' },
    { sl: 2, name: 'Dr. Prasath. C', designation: 'Medical Superintendent', position: 'Member' },
    { sl: 3, name: 'All Head of the Departments', designation: '', position: 'Member' },
    { sl: 4, name: 'Mr. Ananth M', designation: '', position: 'Students Representative' },
    { sl: 5, name: 'Dr. Sumathi. S', designation: '', position: 'Secretary' },
  ];

  const pdfPath = '/assets/document/committee/college-concil/College Concil committee.pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>College Council Committee</h1>
      </header>

      <section className="pharma-description">
        <p>
          The College Council Committee is the apex body responsible for overseeing the overall
          academic and administrative governance of the institution. It formulates policies,
          coordinates between departments, and ensures the smooth functioning of all academic
          activities in accordance with regulatory standards.
        </p>
      </section>

      <section className="pharma-table-section">
        <div className="ct-table-wrapper">
          <table className="pharma-table ct-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.sl}>
                  <td className="ct-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation">{m.designation}</td>
                  <td data-label="Position">{m.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <div className="ct-doc-btn-wrap">
        <a href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
      </div>
    </div>
  );
};

export default CollegeCouncil;
